import { useEffect } from 'react';
import throttle from 'lodash.throttle';
import '../../../../components/animations/animations.less';

const animationRunner = throttle(() => {
  const elList = document.querySelectorAll('[data-animation-type]');
  const scroll = window.scrollY || window.pageYOffset;
  const viewport = {
    top: scroll,
    bottom: scroll + window.innerHeight,
  };

  elList.forEach((el) => {
    const elTop = el.getBoundingClientRect().top + scroll;

    const elPosition = {
      top: elTop,
      bottom: elTop + el.clientHeight,
    };
    if (!el.getAttribute('data-animation-start')) {
      if (
        (elPosition.bottom >= viewport.top &&
          elPosition.bottom <= viewport.bottom) ||
        (elPosition.top <= viewport.bottom && elPosition.top >= viewport.top)
      ) {
        el.setAttribute('data-animation-start', 'true');
      }
    }
  });
}, 1000);

const AnimationRunner = () => {
  useEffect(() => {
    window.addEventListener('scroll', animationRunner);
    setTimeout(() => {
      animationRunner();
    }, 1000);

    return () => {
      window.removeEventListener('scroll', animationRunner);
    };
  }, []);
  return null;
};

export default AnimationRunner;
